export enum UserRoles {
  superAdmin = 'superAdmin',
  admin = 'admin',
  tenant = 'tenant',
  dependiente = 'dependiente',
  vigilant = 'vigilant',
  proprietor = 'proprietor',
  committee = 'committee',
  collaborator = 'collaborator',
  external = 'external',
  customized = 'customized',
}

export enum ColumnToExcelDB {
  unit_id = 'Unidad',
  user_name = 'Nombre Completo',
  is_tenant = '¿Es residente?',
  is_proprietor = '¿Es propietario?',
  is_committe = '¿Es miembro de la junta?',
  user_email = 'Correo electrónico',
  phone_code = 'Código de país',
  phone_detail = 'Número de teléfono'
}
export interface PhoneDetail {
  countryCode: string;
  dialCode: string;
  e164Number: string;
  nationalNumber: string;
}

export interface UserBiometric {
  updatedFacial: boolean;
  facial: UserBiometricFacial;
}

export interface UserBiometricFacial {
  facialPhotoUrl: string;
  updatedAt: Date;
}

export interface UserFeature {
  feature: string;
  enable: boolean;
}
export interface User {
  id: string;
  uid?: string;

  email: string;
  name: string;
  lastName: string;
  phone: string;
  phoneDetail: PhoneDetail;
  codeWhatsapp: string;
  dni: string;
  photoUrl: string;
  superUser: boolean;
  config: any | string;

  termsConditions: {
    eventAt: Date;
    version: string;
    platform: string;
    history?: { version: string; eventAt: Date; platform: string }[];
  };

  i18n: string;

  lastConnection?: Date;
  biometric?: UserBiometric;
  updatedAt?: Date;
  createdAt?: Date;
  features?: UserFeature[];
}

export interface UserInfoTab {
  id: string,
  name: string,
  email: string,
  dni: string,
  phoneDetail: any,
  unit: {
    unitId: string,
    unitNumber: string
  },
  roles: string[],
  userBuilding: string,
  status: string,
  inCommittee: boolean,
  biometric?: UserBiometric,
  features: { feature: string, enable: boolean }[]
}

interface Paginated {
  totalDocs: number,
  limit: number,
  page: number,
  totalPages: number,
  nextPage: number,
  prevPage: number,
  pagingCounter: number,
  hasPrevPage: boolean,
  hasNextPage: boolean,
  docs: UserInfoTab[]
}

export interface ResponsePaginatedUsers {
  data: Paginated
}

export interface PayloadUpdateUser {
  dni?: string | null;
  name: string;
  roles: UserRoles[];
  phone?: string;
  email?: string;
  unit?: string;
  building?: string;
  phoneDetail?: {
    countryCode: string;
    dialCode: string;
    e164Number: string;
    nationalNumber: string;
  };
  biometric?: UserBiometric;
  sendRegistrationNotification?: boolean;
  features?: string[];
}
export interface ExcelInfoToUpload {
  originalData: OriginalDataFromUsersXLSX[];
}

export type OriginalDataFromUsersXLSX = {
  [key in ColumnToExcelDB]?: string | null;
}

export interface PayloadUpdateTmpUser {
  name: string;
  roles: UserRoles[];
  email: string;
  unit: string;
}

export enum PlatformDevice {
  ios = 'ios',
  android = 'android',
  webpage = 'webpage'
}

export interface DevicePermissions {
  notification: boolean;
  contact: boolean;
  multimedia: boolean;
  microphone: boolean;
  recordVideos: boolean;
}

export interface DeviceInformation {
  permissions: DevicePermissions;
  platform: PlatformDevice;
  osVersion: string;
  appVersion: string;
  updatedAt: string;
  id: string;
}

export enum TmpUserStatus {
  accepted = 'accepted',
  created = 'created',
  deleted = 'deleted'
}

export enum UserStatus {
  active = 'active',
  inactive = 'inactive'
}

export interface UserI18nConfig {
  locale: string;
  timezone: string;
}

export interface UserBiometricFacialPayload {
  facialPhotoUrl: string;
  updatedAt: string;
}

export interface UserBiometricPayload {
  updatedFacial: boolean;
  facial: UserBiometricFacialPayload;
}

export interface UserSessionUser {
  id: string;
  name: string;
  email: string;
  biometric: UserBiometricPayload;
  i18n: UserI18nConfig;
  phoneDetail: PhoneDetail;
  termsAccepted: boolean;
}

export interface UserSessionBuilding {
  id: string;
  name: string;
  status: string;
  i18n: UserI18nConfig;
  ico: string;
}

export interface UserSessionUnit {
  id: string;
  number: string;
  building: UserSessionBuilding;
  roles: string[];
  permisos: string[];
}

export interface UserSession {
  user: UserSessionUser;
  units: UserSessionUnit[];
  createdAt: string;
  status: string[];
}

export interface AssistantValidateEmailResponse {
  success: boolean;
}